// extracted by mini-css-extract-plugin
export var orderDetails = "_qp-2";
export var orderImage = "_qp-1";
export var orderMeta = "_qp-3";
export var orderSummary = "_qp-0";
export var rightArrow = "_qp-4";